export default {
  path: 'laowu',
  component: () => import(/* webpackChunkName: "lecturer-list" */ '@/pages/laowu/laowuList'),
  meta: {title:'劳务代开'},
  children: [
      {
          path: 'apply',
          component: () => import(/* webpackChunkName: "article-create" */ '@/pages/laowu/ApplyInvoice'),
          meta: { title: '申请开票' },
      },
		{
		path: 'detail',
		component: () => import(/* webpackChunkName: "article-create" */ '@/pages/laowu/invoiceDetails'),
		meta: { title: '开票详情' },
		}
  ]
}